export enum TransactionEntityType {
Customer,
Supplier,
Employee,
Creditor,
Debtor,
Treasury,
}
